import Plyr from 'plyr';

const mediaPlayer = function () {

	const videoBG = document.querySelectorAll('.videobg-wrapper video')

	if (!videoBG)
		return

	videoBG.forEach(player => {
		const type = player.dataset.type
		const playerId = player.getAttribute('id')
		console.log(`video BG found: #${playerId}`)
		// const playerSrc = player.getAttribute('data-src')
		const mplay = new Plyr('#' + playerId, {
			settings: '',
			invertTime: false,
			controls: [],
			clickToPlay: false,
			muted: true,
			autoplay: true,
			loop: {
				active: true
			}
		});
		mplay.on('ready', (event) => {
			// console.log('Plyr ready...')
			const instance = event.detail.plyr;
		});
	})


}

export default mediaPlayer
